import React, { useEffect, useState } from "react";
import styles from "./leave-request-view.module.css";
import LeaveStatOverview from "../leave-stat-overview/leave-stat-overview";
import { toast } from "react-toastify";
import {
  getAttendanceStat,
  getLeaveOverview,
} from "../../../../services/holiday_leave";
import LeaveHeaderWithMonthYear from "../leave-header-with-month-year/LeaveHeaderWithMonthYear";
import LeaveRequestListView from "../leave-request-list-view/leave-request-list-view";
import { PAGE_LIMIT } from "../../../../constants/common";
import LeaveDetailModal from "../leave-detail-modal/leave-detail-modal";

const LeaveRequestView = ({ leaveType, filterData }) => {
  const [loading, setLoading] = useState(false);
  const [overviewStatistics, setOverviewStatistics] = useState({});
  const [leaveRequestList, setLeaveRequestList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    fetchLeaveStatistics();
  }, []);

  useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchLeaveRequestList();
    }
  }, [leaveType, filterData, selectedMonth, selectedYear]);

  const fetchLeaveStatistics = async () => {
    try {
      setLoading(true);
      const resp = await getAttendanceStat();
      const data = resp?.data?.data;
      const buildObject = {
        total_teachers: data?.totalTeachers,
        present_teachers: data?.presentTeachers,
        teachers_on_leave: data?.teachersOnLeave,
        absent_teachers: data?.absentTeachers,
      };
      setOverviewStatistics(buildObject);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Error Retrieving Stats");
    } finally {
      setLoading(false);
    }
  };

  const fetchLeaveRequestList = async () => {
    try {
      setLoading(true);
      const payload = {
        page: 1,
        pageSize: PAGE_LIMIT,
        month: selectedMonth,
        year: selectedYear,
        sort: filterData,
        status: leaveType === "All Leaves" ? "" : leaveType,
      };
      const resp = await getLeaveOverview(payload);
      const data = resp?.data;

      setLeaveRequestList(data?.data);
      setTotalCount(data?.totalRecords);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Error Retrieving Stats");
    } finally {
      setLoading(false);
    }
  };

  const openLeavePopup = (data) => {
    setIsModalOpen(true);
    setModalData(data);
  };

  const onDateChange = (date) => {
    setSelectedMonth(date.month);
    setSelectedYear(date.year);
  };

  const modalClose = () => {
    fetchLeaveRequestList();
    setIsModalOpen(false);
  };

  return (
    <div>
      <LeaveStatOverview overviewStatistics={overviewStatistics} />
      <LeaveHeaderWithMonthYear onDateChange={onDateChange} />
      <LeaveRequestListView
        onViewDetails={openLeavePopup}
        leaveList={leaveRequestList}
        totalCount={totalCount}
      />
      {isModalOpen ? (
        <LeaveDetailModal
          detailsData={modalData}
          modalOpen={isModalOpen}
          modalClose={modalClose}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default LeaveRequestView;
